import { render, staticRenderFns } from "./area-window.vue?vue&type=template&id=4badaf75&scoped=true"
import script from "./area-window.vue?vue&type=script&lang=js"
export * from "./area-window.vue?vue&type=script&lang=js"
import style0 from "./area-window.vue?vue&type=style&index=0&id=4badaf75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4badaf75",
  null
  
)

export default component.exports